
import React from 'react';
import { Link } from 'react-router-dom';
import './ToolPage.css';

const ToolPage = () => {
  return (
    <div className="toolpage-dashboard">
      <h2 style={{ textAlign: 'center', marginBottom: 32 }}>Tools Dashboard</h2>
      <div className="toolpage-grid">
        {/* Tool 1 Card */}
          <div className="toolpage-card">
            <div style={{width: '100%'}}>
              <h3>Tool 1: Image Editor</h3>
              <div style={{fontSize: 14, color: '#444', marginBottom: 8}}>
                Edit and enhance images directly in your browser with a modern, easy-to-use interface.
              </div>
              <ul>
                <li><b>Crop:</b> Select and crop any region of your image with drag handles.</li>
                <li><b>Resize:</b> Change image dimensions to your needs.</li>
                <li><b>Rotate:</b> Rotate images to any angle.</li>
                <li><b>Brightness & Contrast:</b> Fine-tune image appearance.</li>
                <li><b>Text Overlay:</b> Add and position custom text on your image.</li>
                <li><b>Download:</b> Save your edited image in PNG, JPG, or WebP format.</li>
                <li>All editing is done locally—no uploads required.</li>
              </ul>
              <Link to="/tool/tool1" style={{textDecoration: 'none'}}>
                <button type="button" tabIndex={-1}>
                  Open Tool
                </button>
              </Link>
            </div>
          </div>
        {/* Tool 2 Card */}
          <div className="toolpage-card">
            <div style={{width: '100%'}}>
              <h3>Tool 2: PDF Tools</h3>
              <div style={{fontSize: 14, color: '#444', marginBottom: 8}}>
                All-in-one PDF utility: convert, compress, and manage PDF and Word files directly in your browser.
              </div>
              <ul>
                <li><b>Image to PDF:</b> Combine multiple images into a single PDF file.</li>
                <li><b>PDF to Image:</b> Convert each PDF page to a downloadable image (PNG).</li>
                <li><b>Compress PDF:</b> Reduce PDF file size (best for image-heavy PDFs).</li>
                <li><b>Word to PDF:</b> Convert .docx Word documents to PDF.</li>
                <li><b>PDF to Word:</b> Extract text from PDF and save as .docx (text only).</li>
                <li><b>PDF Type Conversion:</b> Save as PDF/A, PDF/X, or standard PDF (demo).</li>
                <li>All tools run fully in your browser—no uploads required.</li>
              </ul>
              <Link to="/tool/tool2" style={{textDecoration: 'none'}}>
                <button type="button" tabIndex={-1}>
                  Open Tool
                </button>
              </Link>
            </div>
          </div>
        {/* Tool 3 Card */}
        <Link to="/tool/tool3" className="toolpage-card">
          <div style={{width: '100%'}}>
            <h3>Tool 3</h3>
            <div style={{
              background: '#eaf1fb',
              color: '#2355d6',
              borderRadius: 6,
              padding: '6px 10px',
              fontSize: 13,
              fontWeight: 600,
              marginBottom: 8,
              textAlign: 'center',
              minHeight: 38
            }}>
              Coming Soon
            </div>
            <button type="button" tabIndex={-1}>
              Open Tool
            </button>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default ToolPage;
